import { createPayload } from './common'

export default (type, request, data) => (dispatch) => {
  dispatch(createInitialAction(type))
  request(data)
  .then(
    response => dispatch(createSuccessAction(type, response)),
    error => dispatch(createErrorAction(type, error))
  )
}

const createInitialAction = (type) => ({
  type: `${type}_INITIAL`,
  payload: {
    isPending: true,
    isComplete: false,
    isError: false,
    error: null,
    ...createPayload(null)
  }
})

const createSuccessAction = (type, data) => ({
  type: `${type}_SUCCESS`,
  payload: {
    isPending: false,
    isComplete: true,
    isError: false,
    error: null,
    ...createPayload(data)
  }
})

const createErrorAction = (type, data) => ({
  type: `${type}_ERROR`,
  payload: {
    isPending: false,
    isComplete: false,
    isError: true,
    error: data,
    ...createPayload(null)
  }
})



// WEBPACK FOOTER //
// ./src/store/utils/asyncAction.js